<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination :background="background" :current-page.sync="currentPage"
                   :page-size.sync="pageSize" :layout="layout" :page-sizes="pageSizes"
                   :total="total" :pager-count="pagerCount" v-bind="$attrs"
                   @size-change="handleSizeChange" @current-change="handleCurrentChange" />
  </div>
</template>

<script>

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default () {
        return [10, 20, 30, 50]
      }
    },
    pagerCount: {
      type: Number,
      default: 7
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get () {
        return this.page
      },
      set (val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get () {
        return this.limit
      },
      set (val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
    },
    handleCurrentChange (val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  // height: 60px;
  // display: flex;
  // justify-content: center;
  // margin-top: 24px;
  text-align: center;
  /deep/.el-pagination {
    .btn-prev,
    .btn-next {
      background-color: #fff;
      border: 1px solid #d9d9d9;
    }
    .el-pagination__total,
    .el-pagination__jump {
      color: #262b30;
    }
    .el-pagination__sizes {
      .el-input__inner {
        margin-bottom: 3px;
      }
    }
    .el-pagination__jump .el-input__inner {
      color: #262b30;
    }
    .el-pager {
      li {
        background-color: #fff;
        color: #262b30;
        line-height: 26px;
        border: 1px solid #d9d9d9;
        &:not(.disabled).active {
          color: #0078fc;
          background-color: #fff;
          border: 1px solid #0078fc;
          border-radius: 2px;
        }
      }
    }
  }
}
.pagination-container.hidden {
  display: none;
}
</style>
